import { ChevronLeft } from '@styled-icons/heroicons-outline/ChevronLeft';
import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { ScrollButtonGroupSchema } from '@/views/sports/components/ScrollButtonGroup/styles/ScrollButtonGroup.styles';

export const scrollButtonGroupStyles: ScrollButtonGroupSchema = {
  iconButtonScrollRightSvg: {
    as: ChevronRight,
    color: 'alpha.800',
    sx: {
      w: '9px',
    },
  },
  iconButtonScrollRight: {
    bgGradient: 'linear(to-b, alpha.100, alpha.500)',
    color: 'alpha.900',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.3)',
    border: 'none',
    borderRadius: 'base',
    h: 9,
    w: 'auto',
    minW: '4',
    cursor: 'pointer',
    sx: {
      bgGradient: 'linear(to-b, alpha.200, alpha.500)',
      ':active': {
        '&:after': {
          content: 'none',
        },
      },
    },
  },
  iconButtonScrollLeftSvg: {
    as: ChevronLeft,
    color: 'alpha.800',
    sx: {
      w: '9px',
    },
  },
  iconButtonScrollLeft: {
    bgGradient: 'linear(to-b, alpha.100, alpha.500)',
    color: 'alpha.900',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.3)',
    border: 'none',
    borderRadius: 'base',
    h: 9,
    w: 'auto',
    minW: '4',
    cursor: 'pointer',
    sx: {
      ':active': {
        bgGradient: 'linear(to-b, alpha.200, alpha.500)',
        '&:after': {
          content: 'none',
        },
      },
    },
  },
  flexWrapper: {
    bg: 'alpha.400',
    borderRadius: 'md',
    boxShadow: '0 1px rgba(255, 255, 255, .05)',
  },
  buttonGroupSports: {
    display: 'inline-flex',
    flex: '1',
    overflowX: 'auto',
    p: '1',
    mr: ['0', '0', '0', '42px'],
    spacing: '1',
    whiteSpace: 'nowrap',
    h: [null, null, '36px'],
    bg: 'rgb(24, 44, 59)',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    pos: ['relative', null, null, 'absolute'],
    w: ['120px', 'auto', null],
    inset: 0,
    sx: { '::-webkit-scrollbar': { display: 'none' } },
  },
  buttonGroupScrolls: {
    display: ['none', null, null, 'inline-flex'],
    pr: '2px',
    pos: 'relative',
    borderRadius: 'base',
    spacing: '1',
    ml: 'auto',
    gap: 0.5,
    isAttached: true,
  },
  scrollIndicator: {
    w: 2,
    h: '0.5',
    bg: 'alpha.200',
    pos: 'absolute',
    bottom: 'px',
    transition: 'all 0.2s ease',
  },
};
